export default class CustomerRegistration {
  name = "";
  street = "";
  zip = "";
  city = "";
  country = null;
  province = null;

  contactName = "";
  contactMail = "";
  contactPhone = "";

  initialUser = null;
}